import moment from "moment"
import { Button, Col, Row } from "react-bootstrap"
import { ChevronDown, ChevronUp } from "react-bootstrap-icons"
import BootstrapTable, { ColumnDescription } from "react-bootstrap-table-next"
import filterFactory, { textFilter } from "react-bootstrap-table2-filter"
import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, { CSVExport } from "react-bootstrap-table2-toolkit"
import { useTranslation } from "react-i18next"
import { SearchBar } from "../../components/Tables/Columns"
import CustomTotal from "../../components/Tables/CustomTotal"
import GetVolumeWeight from "../../components/Tables/GetVolumeWeight"
import pageListRenderer from "../../components/Tables/PageListRenderer"
import sizePerPageOptionRenderer from "../../components/Tables/SizePerPageOptionRenderer"
let userFilter: any
const CreditParcelsTable = ({
    creditParcels,
    setShow,
    setButtonId,
    handleOnSelect,
    handleOnSelectAll,
    selectedRows,
    invoiceParcel
}: {
    creditParcels: any
    setShow: Function
    setButtonId: Function
    handleOnSelect: Function
    handleOnSelectAll: any
    selectedRows: number[]
    invoiceParcel: Function
}) => {
    const { t } = useTranslation()
    const onSelect = (row: any, isSelect: any) => {
        handleOnSelect(row, isSelect)
    }
    const selectRow: any = {
        mode: "checkbox",
        clickToSelect: true,
        onSelect: onSelect,
        onSelectAll: handleOnSelectAll,
        selectColumnPosition: "left"
    }
    function parcelCreatedDate(cell: string) {
        if (cell) return moment(cell).format("DD MMM yyyy")
    }

    const onFilter = (value: string | number | null, id: string) => {
        if (!value) value = ""
        if (id === "user") userFilter(value)
    }

    const parcelsColumns = [
        {
            dataField: "uuid",
            text: t("Parcel ID"),
            classes: "highlighted-text"
        },
        {
            dataField: "created_at",
            text: t("Dispatch Date"),
            sort: true,
            formatter: (cell: string, row: Record<string, any>) => {
                return parcelCreatedDate(cell)
            },
            csvFormatter: (cell: string, row: Record<string, any>) => {
                return parcelCreatedDate(cell)
            }
        },
        {
            text: t("Items"),
            dataField: "ParcelItems",
            formatter: (cell: Record<string, any>[], row: Record<string, any>) => {
                return cell?.length
            },
            csvFormatter: (cell: Record<string, any>[]) => {
                return cell?.length
            }
        },
        {
            dataField: "ParcelAddress.country",
            text: t("Destination"),
            // formatter: (cell: string) => {
            //  return <div className="col-3"><Flag code={cell} /></div>
            // },
            csvFormatter: (cell: string | number, row: Record<string, any>) => {
                return cell ? cell : " - "
            }
        },
        {
            text: t("Customer"),
            dataField: "user.user_pin",
            filter: textFilter({
                getFilter: (filter) => {
                    userFilter = filter
                }
            }),
            formatter: (cell: string | number, row: Record<string, any>) => {
                return cell ? (
                    <div>
                        <span className="d-flex">{cell}</span>
                        <span>{row?.user?.name}</span>
                    </div>
                ) : (
                    ""
                )
            },
            csvFormatter: (cell: string | number, row: Record<string, any>) => {
                return cell ? cell + " ," + row?.user?.name : ""
            }
        },
        {
            text: t("Suite"),
            dataField: "ParcelSuite.suite.suite",
            formatter: (cell: string | number) => {
                return cell ? cell : "-"
            },
            csvFormatter: (cell: string | number, row: Record<string, any>) => {
                return cell ? cell : "-"
            }
        },
        {
            dataField: "amount",
            text: t("Charges"),
            sort: true,
            formatter: (cell: string | number, row: Record<string, any>) => {
                return cell ? (
                    <div>
                        <strong>{cell}</strong> {row?.ParcelPayment?.currency}
                    </div>
                ) : (
                    ""
                )
            },
            csvFormatter: (cell: string | number, row: Record<string, any>) => {
                return cell ? cell + " " + row?.ParcelPayment?.currency : ""
            }
        },
        {
            text: t("Invoiced"),
            sort: true,
            dataField: "is_missing_invoice",
            formatter: (cell: number, row: Record<string, any>) => {
                return cell === 1 ? (
                    <span className="is_missing_invoice">{t("yes")}</span>
                ) : (
                    <span className="is_missing_invoice_no">{t("no")}</span>
                )
            },
            csvFormatter: (cell: number, row: Record<string, any>) => {
                return cell === 1 ? t("yes") : t("no")
            }
        },
        // export only columns
        {
            dataField: "awb",
            text: t("AWB"),
            hidden: true
        },
        {
            dataField: "ParcelShipmentTracking.tracking_number",
            text: t("Tracking"),
            hidden: true,
            csvFormatter: (cell: string | number, row: Record<string, any>) => {
                return cell ? cell : "-"
            }
        },
        {
            dataField: "Website.name",
            text: t("Supplier"),
            hidden: true,
            csvFormatter: (cell: string | number, row: Record<string, any>) => {
                return cell ? cell : "-"
            }
        },

        {
            dataField: "dimension_length",
            text: t("Dimensions"),
            hidden: true,
            csvFormatter: (cell: string | number, row: Record<string, any>) => {
                const w = row.dimension_width
                const h = row.dimension_height
                return cell ? cell + " x " + w + " x " + h + "  " + row.dimensions_unit : "-"
            }
        },

        {
            dataField: "weight_value",
            text: t("Actual_Weight"),
            hidden: true,
            csvFormatter: (cell: string | number, row: Record<string, any>) => {
                return cell ? cell + "  " + row.weight_unit : "-"
            }
        }
    ]

    const expandRow = {
        renderer: (row: Record<string, any>): JSX.Element => {
            const actualWeight = row.weight_value
            const l = row.dimension_length
            const w = row.dimension_width
            const h = row.dimension_height

            let volumeWeight = GetVolumeWeight(row)
            return (
                <Row className="expanding-row px-4 py-4">
                    <Col xs={12} sm={12} md={12} lg={5}>
                        <Row className="expand-data">
                            <Col xs={12} sm={12} md={12} lg={5} className="label">
                                {t("AWB")}
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={7} className="value">
                                {row.awb}
                            </Col>
                        </Row>
                        <Row className="expand-data">
                            <Col xs={12} sm={12} md={12} lg={5} className="label">
                                {t("Tracking")}
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={7} className="value">
                                {row.ParcelShipmentTracking?.tracking_number
                                    ? row.ParcelShipmentTracking.tracking_number
                                    : "-"}
                            </Col>
                        </Row>
                        <Row className="expand-data">
                            <Col xs={12} sm={12} md={12} lg={5} className="label">
                                {t("Supplier")}
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={7} className="value">
                                {row?.Website?.name ? row.Website.name : "-"}
                            </Col>
                        </Row>
                        <Row className="expand-data">
                            <Col xs={12} sm={12} md={12} lg={5} className="label">
                                {t("Created Day")}
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={7} className="value">
                                {moment(row.created_at).format("DD MMM yyyy hh:mm A")}
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={5}>
                        <Row className="expand-data">
                            <Col xs={12} sm={12} md={12} lg={5} className="label">
                                {t("Actual_Weight")}
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={7} className="value">
                                <strong>{actualWeight ? actualWeight : ""} </strong>
                                {row.weight_unit ? row.weight_unit : "-"}
                            </Col>
                        </Row>
                        <Row className="expand-data">
                            <Col xs={12} sm={12} md={12} lg={5} className="label">
                                {t("Dimensions")}
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={7} className="value">
                                {l} {l && <i className="bx bx-x"></i>}
                                {w} {w && <i className="bx bx-x"></i>}
                                {h} {l && w && h ? row.dimensions_unit : "-"}
                            </Col>
                        </Row>
                        <Row className="expand-data">
                            <Col xs={12} sm={12} md={12} lg={5} className="label">
                                {t("Volume_Weight")}
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={7} className="value">
                                <strong>{volumeWeight.toFixed(2)} </strong>
                                {row.weight_unit ? row.weight_unit : ""}
                            </Col>
                        </Row>
                    </Col>
                </Row>
            )
        },
        showExpandColumn: true,
        expandByColumnOnly: true,
        expandHeaderColumnRenderer: ({ isAnyExpands }: { isAnyExpands: boolean }) => {
            return <></>
        },
        expandColumnRenderer: ({ expanded }: { expanded: boolean }) => {
            if (expanded) {
                return <ChevronUp color="#2D3748" size={10} className="mx-2 my-3 arrow-icon" />
            }
            return <ChevronDown color="#2D3748" size={10} className="mx-2 my-3 arrow-icon" />
        }
    }

    const options = {
        sizePerPage: 50,
        hideSizePerPage: false,
        hidePageListOnlyOnePage: true,
        sizePerPageOptionRenderer,
        showTotal: true,
        pageListRenderer,
        paginationTotalRenderer: CustomTotal
    }
    const { ExportCSVButton } = CSVExport

    return (
        <div className="table-responsive">
            {parcelsColumns && (
                <ToolkitProvider
                    keyField="id"
                    data={creditParcels}
                    columns={parcelsColumns as ColumnDescription<any, any>[]}
                    search={{ searchFormatted: true }}
                    exportCSV={{
                        fileName: "creditParcelsTable.csv",
                        noAutoBOM: false,
                        exportAll: false,
                        onlyExportFiltered: true
                    }}>
                    {(props) => {
                        return (
                            <div className="table-container my-4">
                                <Row className="search mx-2 credit-parcel-search">
                                    <Col xs={12} sm={6} md={6} lg={6}></Col>
                                    <Col xs={12} sm={6} md={6} lg={6} className="text-align-end">
                                        <Row className="justify-content-end align-items-end">
                                            <Col xs={12} sm={4} md={4} lg={3}>
                                                <SearchBar {...props.searchProps} />
                                            </Col>
                                            {selectedRows?.length > 0 && (
                                                <Col xs={12} sm={4} md={4} lg={3} className="text-align-end">
                                                    <ExportCSVButton
                                                        {...props.csvProps}
                                                        className="btn-outline-primary parcelExportButton">
                                                        Export
                                                    </ExportCSVButton>
                                                </Col>
                                            )}
                                            {selectedRows?.length > 0 && (
                                                <Col xs={12} sm={4} md={4} lg={3} className="text-align-end">
                                                    <Button
                                                        id="btn-primary"
                                                        className="btn btn-primary w-30"
                                                        type="submit"
                                                        onClick={() => invoiceParcel()}>
                                                        {t("Mark as Invoiced")}
                                                    </Button>
                                                </Col>
                                            )}
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className="table-data my-3">
                                    <Col>
                                        <BootstrapTable
                                            {...props.baseProps}
                                            wrapperClasses="table-wrapper my-3 mx-4 "
                                            headerClasses="header-class"
                                            bordered={false}
                                            filter={filterFactory()}
                                            noDataIndication={t("No_Record")}
                                            rowClasses="custom-table-row"
                                            condensed={true}
                                            pagination={paginationFactory(options)}
                                            sort={{
                                                dataField: "created_at",
                                                order: "desc"
                                            }}
                                            expandRow={expandRow}
                                            selectRow={selectRow}
                                        />
                                    </Col>
                                </Row>
                            </div>
                        )
                    }}
                </ToolkitProvider>
            )}
        </div>
    )
}

export default CreditParcelsTable
